import { createSlice } from '@reduxjs/toolkit';
import {
    createMessage,
    updateMessage,
    deleteMessage,
    getMessage,
    getCampaignEchos,
} from '../thunks/salesRepCampaignThunk';
import { toast } from 'react-toastify';

const salesRepCampaignSlice = createSlice({
    name: 'salesRepCampaign',
    initialState: {
        isLoading: false,
        error: null,
        message: {
            id: null,
            name: null,
            message: null,
        },
        echos: [],
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(createMessage.fulfilled, (state, action) => {
                state.isLoading = false;
                if (action.payload.status_code === 200) {
                    toast.success(action.payload.success);
                    for (const [key, value] of Object.entries(state.message)) {
                        state.message[key] = action.payload.message.hasOwnProperty(
                            key
                        )
                            ? action.payload.message[key]
                            : value;
                    }
                } else {
                    toast.error(action.payload.error);
                }
                state.error = null;
            })
            .addCase(createMessage.pending, (state, action) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(createMessage.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
                toast.error(action.payload);
            })
            .addCase(updateMessage.fulfilled, (state, action) => {
                state.isLoading = false;
                if (action.payload.status_code === 200) {
                    toast.success(action.payload.success);
                    for (const [key, value] of Object.entries(state.message)) {
                        state.message[key] = action.payload.message.hasOwnProperty(
                            key
                        )
                            ? action.payload.message[key]
                            : value;
                    }
                } else {
                    toast.error(action.payload.error);
                }
                state.error = null;
            })
            .addCase(updateMessage.pending, (state, action) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(updateMessage.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
                toast.error(action.payload);
            })
            .addCase(deleteMessage.fulfilled, (state, action) => {
                state.isLoading = false;
                if (action.payload.status_code === 200) {
                    toast.success(action.payload.success);
                } else {
                    toast.error(action.payload.error);
                }
                state.error = null;
            })
            .addCase(deleteMessage.pending, (state, action) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(deleteMessage.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
                toast.error(action.payload);
            })
            .addCase(getMessage.fulfilled, (state, action) => {
                state.isLoading = false;
                if (action.payload.status_code === 200) {
                    for (const [key, value] of Object.entries(state.message)) {
                        state.message[key] = action.payload.message.hasOwnProperty(
                            key
                        )
                            ? action.payload.message[key]
                            : value;
                    }
                } else {
                    toast.error(action.payload.error);
                }
                state.error = null;
            })
            .addCase(getMessage.pending, (state, action) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(getMessage.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
                toast.error(action.payload);
            })
            .addCase(getCampaignEchos.fulfilled, (state, action) => {
                state.isLoading = false;
                if (action.payload.status_code === 200) {
                    state.echos = action.payload.echos;
                } else {
                    toast.error(action.payload.error);
                }
                state.error = null;
            })
            .addCase(getCampaignEchos.pending, (state, action) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(getCampaignEchos.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
                toast.error(action.payload);
            });
    },
});

export const actions = salesRepCampaignSlice.actions;
export default salesRepCampaignSlice.reducer;
